import { useState, useEffect } from 'react'
import firebase from '../firebase/compat'
import { client } from './Client'

/**
 * Haalt de datakwaliteitsscore van de eigen organisatie op via de
 * `getDataQualityScore` Cloud Function (europe-west1). `stored` is de
 * bevroren nachtelijke score (de waarheid); `live` is alleen gevuld wanneer
 * expliciet om een actuele stand is gevraagd en is voorlopig gelabeld.
 *
 * AI-CONTEXT: See docs/features/datakwaliteitsscore.md
 *
 * @param {{ live?: boolean }} [options] - live: bereken ook een actuele stand (detailpagina)
 * `growth` is het verschil met de stand van drie maanden terug, of null zonder
 * momentopname (besluit 2026-10-13).
 *
 * @returns {{ stored: object | null, live: object | null, growth: import('../helpers/dashboard/dataQualityDisplay').ScoreGrowth | null, loading: boolean, error: Error | null }}
 */
const useDataQualityScore = ({ live = false } = {}) => {
    const [data, setData] = useState(/** @type {{stored: object|null, live: object|null, growth: object|null} | null} */ (null))
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(/** @type {Error | null} */ (null))

    useEffect(() => {
        let active = true
        setLoading(true)
        setError(null)

        const getDataQualityScore = firebase
            .app()
            .functions('europe-west1')
            .httpsCallable('getDataQualityScore')

        getDataQualityScore({ client, live })
            .then((result) => { if (active) setData(result.data) })
            .catch((err) => {
                console.error('useDataQualityScore error:', err)
                if (active) setError(err)
            })
            .finally(() => { if (active) setLoading(false) })

        return () => { active = false }
    }, [live])

    return { stored: data?.stored ?? null, live: data?.live ?? null, growth: data?.growth ?? null, loading, error }
}

export default useDataQualityScore
